export default "__VITE_ASSET__C$MEW$Rf__"